import { useEffect, useRef } from 'react';
import p5 from 'p5';

interface Particle {
  x: number;
  y: number;
  vx: number;
  vy: number;
}

export const LoginBackground = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const particles = useRef<Particle[]>([]);
  const sketch = useRef<p5>();
  const isMouseOver = useRef(false);

  useEffect(() => {
    if (!containerRef.current) return;

    const s = new p5((p: p5) => {
      p.setup = () => {
        const canvas = p.createCanvas(p.windowWidth, p.windowHeight);
        canvas.parent(containerRef.current!);
        
        // Initialize 100 particles with slower initial velocities
        for (let i = 0; i < 100; i++) {
          particles.current.push({
            x: p.random(p.width),
            y: p.random(p.height),
            vx: p.random(-0.1, 0.1),
            vy: p.random(-0.1, 0.1)
          });
        }

        containerRef.current?.addEventListener('mouseenter', () => {
          isMouseOver.current = true;
        });
        containerRef.current?.addEventListener('mouseleave', () => {
          isMouseOver.current = false;
        });
      };

      p.draw = () => {
        p.clear();
        
        for (let i = 0; i < particles.current.length; i++) {
          const particle = particles.current[i];
          
          if (isMouseOver.current) {
            const dx = p.mouseX - particle.x;
            const dy = p.mouseY - particle.y;
            const dist = p.sqrt(dx * dx + dy * dy);
            
            if (dist < 200) {
              particle.vx += (dx / dist) * 0.05;
              particle.vy += (dy / dist) * 0.05;
            }
          }
          
          particle.x += particle.vx;
          particle.y += particle.vy;
          
          particle.vx *= 0.97;
          particle.vy *= 0.97;
          
          if (particle.x < 0) particle.x = p.width;
          if (particle.x > p.width) particle.x = 0;
          if (particle.y < 0) particle.y = p.height;
          if (particle.y > p.height) particle.y = 0;
          
          p.stroke(255, 100);
          for (let j = i + 1; j < particles.current.length; j++) {
            const other = particles.current[j];
            const d = p.dist(particle.x, particle.y, other.x, other.y);
            if (d < 100) {
              p.line(particle.x, particle.y, other.x, other.y);
            }
          }
          
          p.noStroke();
          p.fill(255);
          p.ellipse(particle.x, particle.y, 4, 4);
        }
      };

      p.windowResized = () => {
        p.resizeCanvas(p.windowWidth, p.windowHeight);
      };
    });

    sketch.current = s;

    return () => {
      s.remove();
      containerRef.current?.removeEventListener('mouseenter', () => {
        isMouseOver.current = true;
      });
      containerRef.current?.removeEventListener('mouseleave', () => {
        isMouseOver.current = false;
      });
    };
  }, []);

  return <div ref={containerRef} className="absolute inset-0" />;
};